<template>
  <Modal
    class="dea-modal-change-activities"
    extra-class="dea-modal--no-footer"
    :visible="visible"
    @modalClose="$emit('close-modal')"
  >
    <template #title>
      Svolgi altre attività oltre alla docenza?
    </template>
    <template #content>
      <div class="dea-modal-change-activities__content-list">
        <Checkbox
          id="no-answer"
          class="dea-checkbox--regular"
          type="radio"
          name="yesNo"
          :checked="checkedActivityList.length === 0"
          @click="emptyList()"
        >
          No, nessuna
        </Checkbox>
        <Checkbox
          id="yes-answer"
          class="dea-checkbox--regular"
          type="radio"
          name="yesNo"
          :checked="!isEmptyList()"
          @click="disabled = false"
        >
          Si
        </Checkbox>
        <div class="dea-modal-change-activities__activities-list">
          <Checkbox
            v-for="(activity, index) in $root.config.activitiesList"
            :id="`checkbox-${index}`"
            :key="index"
            class="dea-checkbox--regular"
            type="checkbox"
            name="activity"
            :value="activity"
            :disabled="disabled && isEmptyList()"
            :checked="checkedActivityList.includes(activity)"
            @change="updateList($event)"
          >
            {{ activity }}
          </Checkbox>
          <div class="dea-modal-change-activities__last-checkbox">
            <Checkbox
              id="`checkbox-final"
              class="dea-checkbox--regular"
              type="checkbox"
              name="activity"
              :value="customActivity"
              :disabled="disabled && isEmptyList()"
              :checked="checkedActivityList.includes(customActivity)"
              @change="checkCustomCheckbox($event)"
            >
              Altro:
              <InputText id="custom-input" v-model="customActivity" :state="inputState" :message="errorMessage" />
            </Checkbox>
          </div>
        </div>
      </div>
      <Buttons class="dea-button--large" @click="saveList()">Salva modifiche</Buttons>
    </template>
  </Modal>
</template>

<script>
import { mapActions } from "vuex";

import Buttons from "@/components/elements/Buttons";
import Checkbox from "@/components/elements/Checkbox";
import InputText from "@/components/elements/InputText";
import Modal from "@/components/patterns/Modal";

export default {
  name: "ChangeActivitiesModal",
  components: { Buttons, Checkbox, InputText, Modal },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkedActivityList: [],
      customActivity: "",
      disabled: true,
      errorMessage: "Inserisci prima l'attività",
      inputState: "",
      loading: false,
    };
  },
  watch: {
    user() {
      this.$emit("close-modal");
    },
  },
  mounted() {
    if (this.user.school_roles) {
      this.checkedActivityList = this.user.school_roles.split(",");
      this.checkedActivityList = this.checkedActivityList.filter(el => el !== " ");
      this.customActivity = this.checkedActivityList.filter(el => {
        return !this.$root.config.activitiesList.includes(el);
      });
      if (Array.isArray(this.customActivity)) this.customActivity = this.customActivity.join(",");
    }
  },
  methods: {
    ...mapActions(["fetchUser", "saveActivities"]),
    checkCustomCheckbox(event) {
      if (event.target.checked) {
        if (!this.customActivity) {
          // eslint-disable-next-line no-param-reassign
          event.target.checked = false;
          this.inputState = "error";
        } else {
          this.inputState = "";
          this.updateList(event);
        }
      }
    },
    emptyList() {
      this.customActivity = "";
      this.disabled = true;
      this.checkedActivityList = [" "];
    },
    isEmptyList() {
      if (
        this.checkedActivityList.length === 0 ||
        (this.checkedActivityList.length === 1 && this.checkedActivityList[0] === " ")
      ) {
        return true;
      }
      return false;
    },
    removeElementFromArray(element) {
      this.checkedActivityList = this.checkedActivityList.filter(el => el !== element);
    },
    updateList(event) {
      if (event.target.checked && event.target.value !== "") {
        this.checkedActivityList.push(event.target.value);
      } else {
        this.removeElementFromArray(event.target.value);
      }
    },
    async saveList() {
      if (this.checkedActivityList.length) {
        document.querySelector("body").classList.add("wait");
        const payload = { userId: this.user.id, userChanges: { school_roles: this.checkedActivityList.join(",") } };
        await this.saveActivities(payload);
        await this.fetchUser(true);
        document.querySelector("body").classList.remove("wait");
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/system.utils";

$input-width-mobile: 150px;

.dea-modal-change-activities {
  &__content-list {
    .dea-checkbox--regular {
      label .dea-checkbox__label {
        font-size: $h-font-size-small;
      }
    }
  }

  &__activities-list {
    margin-left: $space-base;
    margin-top: $space-x-small;
  }

  &__last-checkbox {
    margin-bottom: $space-small;
    margin-top: $space-x-small;

    .dea-checkbox__label {
      display: flex;
      position: relative;

      .dea-input {
        margin-left: $space-large;
        position: absolute;
        top: calc(-100% + #{$space-intermediate} / 2);

        input {
          @include media("<=xs") {
            width: $input-width-mobile;
          }
          height: $space-intermediate;
        }

        &__icon {
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
}
</style>
